import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22countdown-timer.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../fonts/digital-7.ttf%22}],%22variableName%22:%22digitalFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'digitalFont', 'digitalFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
